angular.module('autoremind.dashboard.directives')
    .directive('missedWidget', ['$rootScope',
    function ($rootScope) {
        return {
            templateUrl: 'app/dashboard/widgets/missed/missed.html',
            restrict: 'EA',
            scope: true,
        };
    }]);
//# sourceMappingURL=missed.directive.js.map